import styled, { keyframes } from 'styled-components';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'

export const DeleteModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    z-index: 99;
    overflow: auto;
`;

export const ModalContainer = styled.div`
    background: white;
    padding: 20px;
    border-radius: 8px;
    max-width: 600px;
    width: 100%;
    height: auto;
    max-height: 600px;
    justify-content: center;
    align-items: center;
    display: flex;
    margin-top: 150px;
    flex-direction: column;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const FormSelectDropdownContainer = styled.div`
  align-items: center;
  z-index: 98;
  margin: 12px;
`;


export const FormLabel = styled.label`
  margin-bottom: 8px;
  margin-right: 8px;
  font-size: 16px;
  color: #cc8f2d;
  font-weight: bold;
`;


export const FormSelect = styled.select`
  color: black;
  background: #cc8f2d;
  font-weight: bold;
  border: none;
  padding: 8px;
  border-radius: 8px;
`;


export const FormButton = styled.button`
  background: #cc8f2d;
  border: none;
  border-radius: 4px;
  color: black;
  font-size: 20px;
  margin: 20px;
  cursor: pointer;
  height: 30px;
  width: 200px;
`;



export const ModalCloseButton = styled.button`
  border-radius: 50px;
  background: none;
  white-space: nowrap;
  padding: 2px 8px;
  color: #cc8f2d;
  font-size: 20px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;
  margin:2px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #cc8f2d;
  }
`;


export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const SpinningIcon = styled(AiOutlineLoading3Quarters)`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #cc8f2d;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: ${spin} 1s linear infinite;
`